import { render, staticRenderFns } from "./pricequery.vue?vue&type=template&id=0a4c4279&scoped=true"
import script from "./pricequery.vue?vue&type=script&lang=js"
export * from "./pricequery.vue?vue&type=script&lang=js"
import style0 from "./pricequery.vue?vue&type=style&index=0&id=0a4c4279&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c4279",
  null
  
)

export default component.exports